<template>
  <div>
    <a-card>
      <!-- 查询 -->
      <SearchView
        :renderItem="searchSchema"
        :formLayout="formLayout"
        :initialValues="searchData"
        @fetchSearch="handelSearch"
        :isExpandShowOrNot="false"
      ></SearchView>
    </a-card>
    <a-card style="margin-top:20px;">
      <div class="text-right">
        <a-button @click="toApply" type="primary" class="margin-right-20">
          发起申请
        </a-button>
        <a-button @click="_exportCreditHistory" type="primary">
          导出excel
        </a-button>
      </div>
      <!-- 结果 -->
      <TableView
        :loading="loading"
        :scroll="scroll"
        ref="table"
        :columns="columns"
        :pagination="pageData"
        :data="tableData"
        v-on:handlePagination="handlePagination"
      >
        <!--最终批复额度 slot-->
        <template v-slot:reviewAmount="{ tableRow }">
          <span>{{ tableRow.reviewAmount | formatAmount }}</span>
        </template>
        <!--限额条件—AR超限控货(元) slot-->
        <template v-slot:limitConditionAmount="{ tableRow }">
          <span v-if="tableRow.limitConditionType == 1">
            {{ tableRow.limitConditionAmount | formatAmount }}
          </span>
        </template>
        <!--调减后额度 slot-->
        <template v-slot:reducedAmount="{ tableRow }">
          <span v-if="typeof tableRow.reducedAmount === 'number'">
            {{ tableRow.reducedAmount | formatAmount }}
          </span>
          <!-- <span>{{ tableRow.reducedAmount }}</span> -->
        </template>
        <!--申请后总限额/总额度-->
        <template v-slot:finalAmount="{ tableRow }">
          <span>{{ tableRow.finalAmount | formatAmount }}</span>
        </template>

        <template v-slot:action="{ tableRow }" >
          <template
            v-if="
              permissions.length != 0 &&
                permissionsObj['信用额度'].includes('调减')
            "
          >
            <a
              href="javascript:void(0)"
              @click="$refs.createForm.add(tableRow, companyCode, creditAmount)"
            >
              调整
            </a>
            <a-divider type="vertical" />
          </template>
          <a href="javascript:void(0)" @click="detail(tableRow)">
            查看
          </a>
          <div>
            <template v-if="tableRow.limit">
              <a style="margin-left: 10px" @click="handleLimit">限额延期</a>
            </template>
          </div>
          <div>
            <template v-if="tableRow.special">
              <a style="margin-left: 10px" @click="handleSpecial">专项延期</a>
            </template>
          </div>
        </template>
      </TableView>
    </a-card>
    <!-- v-on="limitChange(tableRow)" v-on="specialChange(tableRow)" -->
    <!-- 调减 modal-->
    <create-form
      ref="createForm"
      name="createForm"
      @getTableData="_getTableData"
    ></create-form>
  </div>
</template>

<script>
import { SearchView, TableView } from 'lxfintech-fe'
import CreateForm from './components/CreateForm'
import mixin from './mixin'
import {
  getTableData,
  getBusinessList,
  getRegionList,
  exportCreditHistory,
  getOverview,
} from './api'
import { arrayToObject } from 'utils/util'
//import moment from 'moment'

const CREDIT_RANGE_TYPE = 4
export default {
  mixins: [mixin],
  components: {
    SearchView,
    TableView,
    CreateForm,
  },
  data() {
    return {
      limit: false,
      special: false,
      scroll: { x: 1900 }, //滚动设置,
      formLayout: 'inline',
      tableData: [],
      loading: false,
      permissions: [],
      companyCode: '',
      creditAmount: {
        totalCreditLimit: '',
      },
    }
  },
  computed: {
    // tab项中对应的权限
    permissionsObj() {
      if (this.permissions) {
        return arrayToObject(this.permissions, 'tab', 'buttons')
      }
      return {}
    },
  },
  mounted() {
    this._getOverview()
    this.searchSchema[0].selectList = this.TYPE_LIST
    this.searchSchema[2].selectList = this.STATUS_LIST
    this.searchSchema[3].selectList = this.LIMIT_LIST
    this._getBusinessList()
  },
  methods: {
    toApply() {
      this.$router.push({
        name: 'credit-application-homepage',
        query: {
          code: this.companyCode,
        },
      })
    },
    //getOverview
    async _getOverview() {
      await getOverview(this.$route.params.id).then(({ data }) => {
        this.creditAmount = data.creditAmount
        this.permissions = data.permissions
        this.companyCode = data.code
        this.searchData.companyCode = this.companyCode
        //table
        this._getTableData()
      })
    },
    //获取角色列表
    _getBusinessList() {
      getBusinessList().then(({ data }) => {
        const selectList = data.map(item => ({
          text: item.name,
          value: item.id,
        }))
        this.searchSchema[1]['selectList'].push(...selectList)
      })
    },

    //获取table数据
    _getTableData() {
      this.loading = true
      const { current, pageSize } = this.pageData
      const query = {
        ...this.searchData,
        size: pageSize,
        current,
      }
      delete query.pageSize
      getTableData(query).then(({ data: { total, records } }) => {
        this.loading = false
        this.tableData = records
        this.pageData.total = total
      })
    },
    //点击查询
    handelSearch(query) {
      for (let key in query) {
        this.searchData[key] = query[key]
      }
      this._getTableData()
    },
    //分页
    handlePagination(pagination) {
      const { current, pageSize, total } = pagination
      this.pageData.current = current
      this.pageData.pageSize = pageSize
      this.pageData.total = total
      this._getTableData()
    },
    // 信控区查询
    async _getRegionList(pid, type) {
      try {
        const { data } = await getRegionList({ pid, type })
        const selectList = data.map(item => ({
          text: item.name,
          value: item.id,
        }))
        this.searchSchema[3]['selectList'] = selectList
      } catch (err) {
        console.log(err)
      }
    },
    changeBusiness(option) {
      this._getRegionList(option, CREDIT_RANGE_TYPE)
    },
    detail(row) {
      const { approveId, isBatch, type } = row
      const id = approveId
      const { cbId, status } = row
      if(cbId != null && (id == "" || id == undefined)){
        this.$router.push({
          path: `/credit-approval/apply-detail/${cbId}`,
          query: {
            type,
            status,
            auto: true,
          },
        })
      }else if (isBatch === 1) {
        this.$router.push({
          name: 'batch-approval-detail',
          params: { bpmId: id },
          query: { type },
        })
      } else {
        this.$router.push({
          path: `/credit-approval/apply-detail/${id}`,
          query: { type, status: 0 },
        })
      }
    },
    _exportCreditHistory() {
      exportCreditHistory(this.companyCode)
    },
    // async limitChange(tableRow){
    //   this.limit = false;
    //   if(tableRow.creditTypeStr == '信用限额' && (tableRow.amountStatusStr == '生效中' || tableRow.amountStatusStr == '已失效') ){
    //     if( tableRow.dateSub <= tableRow.indateEnd && tableRow.indateEnd <= tableRow.dateAdd ){
    //       this.limit = true;
    //     }
    //   }else{
    //     this.limit = false;
    //   }
    // },
    // async specialChange(tableRow){
    //   this.special = true;
    //   if(tableRow.creditTypeStr == '专项额度' && (tableRow.amountStatusStr == '生效中' || tableRow.amountStatusStr == '已失效') ){
    //     this.special = true;
    //   }else{
    //     this.special = false;
    //   }
    // },
    async handleLimit() {
      try {
        this.$router.push({
          path: `/credit-approval/apply/limit-extension-application-detail/${this.companyCode}`,
        })
      } catch (error) {
        console.error(error)
      }
    },
    async handleSpecial() {
      try {
        this.$router.push({
          path: `/credit-approval/apply/special-extension-application-detail/${this.companyCode}`,
        })
      } catch (error) {
        console.error(error)
      }
    },
  },
}
</script>

<style lang="less" scoped></style>
